<script setup lang="ts">
import type { AnimationItem } from 'lottie-web'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Lottie from 'lottie-web'
import animationData from '@/assets/lottie/logo_big/data.json'

if (import.meta.client)
  gsap.registerPlugin(ScrollTrigger)
let animation: AnimationItem | null = null
const $route = useRoute()
const { theme } = useTheme()
const footerRef = ref<HTMLElement>()
let triggerS: globalThis.ScrollTrigger | null = null
// // page2动画
function runAnimation() {
  const wrapper = footerRef.value!.querySelector('.logo-wrapper')
  animation = Lottie.loadAnimation({
    container: wrapper!,
    animationData,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid meet'
    }
  })
  triggerS = ScrollTrigger.create({
    trigger: footerRef.value,
    once: true,
    start: 'top bottom',
    onEnter: () => {
      animation?.play()
      gsap.fromTo(footerRef.value!.querySelector('.logo-wrapper'), { opacity: 0 }, { opacity: 1, duration: 2 })
    },
  })
}

watch(() => $route.name, () => {
  nextTick(triggerS?.refresh)
})

onMounted(() => {
  setTimeout(runAnimation, 10);
})
onUnmounted(() => {
  triggerS?.kill()
})
</script>

<template>
  <div ref="footerRef" class="app-footer">
    <div class="footer-wrap">
      <div class="logo-wrapper" id="footer-logo" />
      <div class="link_list">
        <div class="text_l">
          People・Craft・Purpose
        </div>
        <div class="text-r">
          <NuxtLink target="_blank" href="https://www.facebook.com/Paxgon">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
              <g clip-path="url(#clip0_174_141)">
                <path
                  d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z"
                  :stroke="theme === 'dark' ? '#fff' : '#0C0C0C'" stroke-miterlimit="10" />
                <path class="bg"
                  d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                  fill="#0866FF" />
                <path
                  d="M18.813 10.193H20.28V7H18.069C14.938 7 13.452 8.863 13.452 11.516V14.03H11V17.065H13.452V24.782H17.129V17.062H19.582L20.282 14.028H17.13V11.953C17.1096 11.7232 17.1385 11.4916 17.2147 11.2739C17.291 11.0561 17.4128 10.8571 17.5721 10.6902C17.7314 10.5234 17.9246 10.3924 18.1385 10.3061C18.3525 10.2199 18.5825 10.1803 18.813 10.19"
                  :fill="theme === 'dark' ? '#fff' : '#0C0C0C'" />

              </g>
              <defs>
                <clipPath id="clip0_174_141">
                  <rect width="32" height="32" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </NuxtLink>
          <NuxtLink target="_blank" href="https://www.instagram.com/paxcomm/  ">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
              <g clip-path="url(#clip0_174_144)">
                <path
                  d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z"
                  :stroke="theme === 'dark' ? '#fff' : '#0C0C0C'" stroke-miterlimit="10" />
                <image class="bg" href="@/assets/images/insbg.webp" x="0" y="0" width="32" height="32"
                  preserveAspectRatio="xMidYMid meet" />
                <path
                  d="M12.8164 8.04199C15.1356 7.986 17.4561 7.986 19.7773 8.04199C20.5403 8.01422 21.2983 8.17481 21.9844 8.50977C22.6705 8.84482 23.2636 9.34404 23.7109 9.96289C24.29 10.8267 24.5914 11.847 24.5742 12.8867C24.6072 15.1157 24.6232 17.3472 24.5742 19.5752C24.6218 20.4308 24.4266 21.2824 24.0117 22.0322C23.5967 22.7821 22.9779 23.4003 22.2275 23.8145C21.4574 24.2212 20.5985 24.4318 19.7275 24.4287C17.4378 24.4547 15.1471 24.4777 12.8594 24.4287C12.0348 24.4684 11.2142 24.2883 10.4824 23.9062C9.75068 23.5242 9.13408 22.9541 8.69531 22.2549C8.331 21.5702 8.09512 20.8244 8 20.0547L8.00293 12.4141C8.09829 11.6446 8.33382 10.8988 8.69727 10.2139C9.13024 9.51987 9.73934 8.95284 10.4629 8.57129C11.1865 8.1897 11.9991 8.0072 12.8164 8.04199ZM16.3096 9.61426L14.6084 9.61719C14.0395 9.61444 13.4708 9.614 12.9023 9.625C12.1668 9.55461 11.4314 9.76205 10.8408 10.2061C10.2502 10.6501 9.8466 11.2992 9.70996 12.0254C9.6363 12.3505 9.5956 12.6823 9.58887 13.0156C9.57787 15.1695 9.54988 17.3237 9.58887 19.4766C9.62787 21.6296 10.7162 22.7648 12.7822 22.8408C15.1162 22.9258 17.4542 22.9188 19.7881 22.8408C20.5029 22.8951 21.2128 22.6832 21.7803 22.2451C22.3478 21.8069 22.7331 21.1732 22.8613 20.4678C22.9282 20.2031 22.9664 19.932 22.9766 19.6592C22.9896 17.2042 23.1243 14.7449 22.9033 12.2949C22.8636 11.6268 22.5829 10.9954 22.1143 10.5176C21.6456 10.0399 21.0197 9.74795 20.3525 9.69531C19.0077 9.5896 17.6575 9.56248 16.3096 9.61426ZM16.3262 11.9727C17.4611 11.9827 18.5466 12.4402 19.3467 13.2451C20.1465 14.05 20.5964 15.1378 20.5996 16.2725C20.5996 17.124 20.3467 17.9564 19.873 18.6641C19.3994 19.3717 18.7267 19.9234 17.9395 20.248C17.1522 20.5727 16.286 20.6563 15.4512 20.4883C14.6165 20.3202 13.8502 19.9076 13.25 19.3037C12.6498 18.6998 12.2421 17.9314 12.0791 17.0957C11.9161 16.2599 12.0056 15.3946 12.335 14.6094C12.6644 13.8242 13.2192 13.1539 13.9297 12.6846C14.6402 12.2152 15.4746 11.9675 16.3262 11.9727ZM17.3545 13.7275C16.8608 13.5173 16.3152 13.4585 15.7881 13.5586C15.2611 13.6587 14.7757 13.9127 14.3936 14.2891C14.0114 14.6655 13.7496 15.1474 13.6416 15.6729C13.5337 16.1984 13.5843 16.7446 13.7871 17.2412C13.99 17.7379 14.3362 18.1632 14.7812 18.4629C15.2263 18.7626 15.7505 18.9236 16.2871 18.9248C17.0007 18.9282 17.687 18.6493 18.1953 18.1484C18.7036 17.6476 18.9928 16.9655 19 16.252C19.0067 15.7154 18.8536 15.1887 18.5605 14.7393C18.2676 14.29 17.8479 13.9378 17.3545 13.7275ZM20.8115 10.8545C21.0494 10.8761 21.2741 10.9799 21.4463 11.1484C21.6428 11.341 21.7551 11.6038 21.7588 11.8789C21.7517 12.1505 21.6393 12.4085 21.4453 12.5986C21.2512 12.7888 20.9905 12.896 20.7188 12.8975C20.4469 12.8988 20.1843 12.7948 19.9883 12.6064C19.7922 12.4181 19.6776 12.1604 19.668 11.8887C19.6676 11.752 19.6939 11.6165 19.7461 11.4902C19.7983 11.364 19.8759 11.2497 19.9727 11.1533C20.0694 11.0569 20.1841 10.9804 20.3105 10.9287C20.437 10.877 20.5724 10.8506 20.709 10.8516L20.8115 10.8545Z"
                  :fill="theme === 'dark' ? '#fff' : '#0C0C0C'" />
              </g>
              <defs>
                <clipPath id="clip0_174_144">
                  <rect width="32" height="32" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </NuxtLink>
          <NuxtLink target="_blank" href="https://www.youtube.com/user/paxgoncomm">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
              <path
                d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z"
                :stroke="theme === 'dark' ? '#fff' : '#0C0C0C'" stroke-miterlimit="10" />
              <path class="bg"
                d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                fill="#FF0033" />
              <path
                d="M18.363 16.07L14.474 17.95C14.4022 17.9847 14.3228 18.0006 14.2431 17.9962C14.1635 17.9919 14.0863 17.9673 14.0187 17.925C13.9512 17.8826 13.8955 17.8238 13.8569 17.754C13.8183 17.6842 13.798 17.6058 13.798 17.526V13.851C13.7981 13.7721 13.8181 13.6944 13.8561 13.6252C13.8941 13.556 13.9488 13.4975 14.0153 13.455C14.0818 13.4125 14.1579 13.3873 14.2367 13.3819C14.3154 13.3765 14.3943 13.391 14.466 13.424L18.354 15.218C18.422 15.2489 18.4814 15.2959 18.5271 15.355C18.5727 15.4141 18.6033 15.4834 18.616 15.557C18.6306 15.5953 18.633 15.6372 18.623 15.677C18.6187 15.7598 18.5923 15.8399 18.5463 15.9088C18.5004 15.9778 18.4367 16.0332 18.362 16.069M15.617 9C7.14799 9 7 9.753 7 15.635C7 21.517 7.14799 22.271 15.617 22.271C24.086 22.271 24.235 21.518 24.235 15.636C24.235 9.754 24.087 9.001 15.617 9.001"
                :fill="theme === 'dark' ? '#fff' : '#0C0C0C'" />

            </svg>
          </NuxtLink>
          <NuxtLink target="_blank" href="https://www.linkedin.com/company/paxgon ">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
              <g clip-path="url(#clip0_174_153)">
                <path
                  d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z"
                  :stroke="theme === 'dark' ? '#fff' : '#0C0C0C'" stroke-miterlimit="10" />
                <path class="bg"
                  d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                  fill="#0A66C2" />
                <path
                  d="M19.7998 13.0176C21.6525 13.0178 23.0526 14.2732 23.0527 17.0088V22.4795H20.0957V17.3789C20.0956 16.196 19.6511 15.3096 18.6162 15.3096C18.2893 15.3381 17.9791 15.4669 17.7285 15.6787C17.4779 15.8905 17.2994 16.1747 17.2168 16.4922C17.152 16.7328 17.1268 16.9827 17.1426 17.2314V22.4795H14.1836V16.1211C14.1836 15.0132 14.1094 14.0522 14.1094 13.2383H16.7705L16.917 14.4951H16.9922C17.294 14.0284 17.7113 13.6475 18.2031 13.3887C18.6337 13.1621 19.1092 13.0351 19.5938 13.0176H19.7998ZM12.7051 22.4785H9.74805V12.8682H12.7051V22.4785ZM11.2266 9.17773C11.4219 9.17195 11.6171 9.20636 11.7988 9.27832C11.9804 9.35027 12.1458 9.45785 12.2842 9.5957C12.4225 9.7336 12.5309 9.89873 12.6035 10.0801C12.6761 10.2615 12.7111 10.4561 12.7061 10.6514C12.7175 10.8484 12.6873 11.046 12.6172 11.2305C12.5469 11.4151 12.4375 11.583 12.2979 11.7227C12.1583 11.8622 11.9911 11.9708 11.8066 12.041C11.622 12.1113 11.4238 12.1423 11.2266 12.1309C11.0372 12.1384 10.8483 12.1076 10.6709 12.041C10.4933 11.9743 10.3301 11.8727 10.1924 11.7422C10.0547 11.6117 9.94431 11.4549 9.86816 11.2812C9.79203 11.1075 9.75167 10.9201 9.74902 10.7305C9.74197 10.531 9.7749 10.3321 9.8457 10.1455C9.91649 9.95892 10.0236 9.78815 10.1611 9.64355C10.2988 9.49891 10.4645 9.38271 10.6475 9.30273C10.8302 9.22289 11.0271 9.18059 11.2266 9.17773Z"
                  :fill="theme === 'dark' ? '#fff' : '#0C0C0C'" />

              </g>
              <defs>
                <clipPath id="clip0_174_153">
                  <rect width="32" height="32" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </NuxtLink>
          <!-- <NuxtLink target="_blank" href="www.baidu.com">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
              <g clip-path="url(#clip0_174_159)">
                <path
                  d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z"
                  :stroke="theme === 'dark' ? '#fff' : '#0C0C0C'" stroke-miterlimit="10" />

                <path class="bg"
                  d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                  fill="#E50025" />
                <path
                  d="M22.4521 13.2745C22.3275 12.1943 21.8982 11.1718 21.2144 10.3263C20.5306 9.48081 19.6204 8.84724 18.5901 8.49952C16.9633 7.88144 15.1745 7.83559 13.5181 8.36953C12.3041 8.70523 11.2226 9.40601 10.4201 10.3769C9.61772 11.3479 9.13316 12.542 9.03211 13.7975C8.8845 15.1475 9.24925 16.5037 10.0541 17.5975C10.3161 17.9663 10.661 18.2684 11.0611 18.4795C11.3341 18.6225 11.4071 18.5885 11.4801 18.2925C11.5481 18.0175 11.6011 17.7365 11.6881 17.4675C11.7421 17.3475 11.7587 17.214 11.7359 17.0843C11.7131 16.9547 11.6518 16.8349 11.5601 16.7405C11.4818 16.6435 11.4172 16.5362 11.3681 16.4215C10.9028 15.4974 10.7701 14.441 10.9925 13.4305C11.2149 12.42 11.7788 11.5169 12.5891 10.8735C13.2939 10.307 14.141 9.94556 15.0377 9.82878C15.9343 9.71201 16.8458 9.84443 17.6721 10.2115C18.2619 10.4303 18.7869 10.7947 19.1981 11.2708C19.6093 11.7468 19.8934 12.3192 20.0241 12.9345C20.4074 14.466 20.177 16.0866 19.3821 17.4505C19.1527 17.9133 18.8051 18.3073 18.3746 18.5926C17.944 18.878 17.4457 19.0446 16.9301 19.0755C16.5294 19.1169 16.1277 19.0062 15.8047 18.7654C15.4817 18.5247 15.2609 18.1714 15.1861 17.7755C15.1472 17.4726 15.178 17.1648 15.2761 16.8755C15.4921 16.1305 15.7151 15.3875 15.9271 14.6425C16.0526 14.2359 16.107 13.8107 16.0881 13.3855C16.0875 13.1867 16.0408 12.9907 15.9517 12.813C15.8625 12.6352 15.7333 12.4806 15.5742 12.3613C15.4152 12.242 15.2306 12.1612 15.035 12.1253C14.8394 12.0894 14.6382 12.0994 14.4471 12.1545C14.1699 12.2248 13.9131 12.3592 13.6972 12.5467C13.4813 12.7343 13.3124 12.9699 13.2041 13.2345C13.0025 13.6769 12.8924 14.1553 12.8802 14.6413C12.868 15.1272 12.954 15.6106 13.1331 16.0625C13.1809 16.1905 13.1892 16.3298 13.1571 16.4625C12.8441 17.7755 12.5621 19.0965 12.2151 20.3995C11.8598 21.6404 11.7481 22.9382 11.8861 24.2215C11.9191 24.4074 11.9659 24.5906 12.0261 24.7695L12.5771 24.8865C12.5931 24.8655 12.6771 24.7185 12.7521 24.5645C13.3458 23.5563 13.7996 22.472 14.1011 21.3415C14.2191 20.7945 14.3801 20.2555 14.5261 19.7145C14.5411 19.6585 14.5321 19.5735 14.6011 19.5545C14.6701 19.5355 14.6951 19.6215 14.7291 19.6675C14.8884 19.8868 15.0892 20.0727 15.3201 20.2145C15.917 20.5881 16.6181 20.7599 17.3201 20.7045C18.518 20.656 19.653 20.1559 20.4971 19.3045C21.2844 18.5297 21.8736 17.5767 22.2148 16.5261C22.5559 15.4754 22.6391 14.3581 22.4571 13.2685"
                  :fill="theme === 'dark' ? '#fff' : '#0C0C0C'" />
              </g>
              <defs>
                <clipPath id="clip0_174_159">
                  <rect width="32" height="32" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </NuxtLink> -->
        </div>
      </div>
      <div class="no_copy">
        © {{ new Date().getFullYear() }} Paxgon Communications Sdn. Bhd. All Rights Reserved
        <span>/</span>
        <NuxtLink target="_blank" href="https://ufrontend.com/">Powered By Union Frontend</NuxtLink>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.app-footer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 20px;
  padding-bottom: 59px;
  color: var(--fontColor);
  position: relative;

  .footer-wrap {
    max-width: 1500px;
    width: 100%;
  }

  .logo-wrapper {
    width: 100%;
    aspect-ratio:  1500 / 380;
    // height: 380px;
    overflow: visible;

    :deep(svg) {
      display: block;
      overflow: visible;

      g {
        path {
          stroke: var(--fontColor) !important;
          fill: var(--fontColor) !important;
        }

        &:nth-of-type(5) {
          path {
            stroke: rgb(231, 22, 24) !important;
            fill: rgb(231, 22, 24) !important;
          }
        }

      }

    }

  }

  .link_list {
    display: flex;
    justify-content: space-between;
    margin-top: 65px;

    .text_l {
      font-size: 26px;
      font-weight: 300;
    }

    .text-r {
      display: flex;
      gap: 13px;

      a {
        width: 32px;
        height: 32px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        border-radius: 50%;

        svg {
          width: 100%;

          .bg {
            transition: transform .3s cubic-bezier(.645, .045, .355, 1);
            transform: translateY(100%);
          }
        }

        @media (any-hover: hover) {
          &:hover {
            svg {
              .bg {
                transform: translateY(0%);
              }
            }
          }
        }
      }
    }
  }

  .no_copy {
    font-size: 14px;
    font-weight: 300;
    margin-top: 169px;
    text-align: left;
    span{
      color: #999;
      opacity: 0.8;
      margin: 0 5px 0 4px;
    }
    a{
      color: var(--fontColor);
      text-decoration: none;
      transition: transform .3s;
      position: relative;
      &::after{
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: var(--fontColor);
        opacity: 0.8;
        transition: transform .3s;
        transform: scaleX(0);
        transform-origin: left;
      }
      &:hover{
        &::after{
          transform: scaleX(1);
        }
      }
    }
  }
}

.xs {
  .app-footer {
    padding: 0px 20px;
    padding-bottom: 24px;

    .logo-wrapper {
      height: 66.27px;
    }

    .footer-wrap {
      width: 100%;
      max-width:none;
    }

    .link_list {
      flex-direction: column;
      gap: 20px;
      margin-top: 60px;

      .text_l {
        font-size: 20px;
        text-align: center;
      }

      .text-r {
        justify-content: center;

        a {
          width: 44px;
          height: 44px;
          transition: transform .3s;

          &:active {
            transform: scale(1.1);
          }

          svg {
            height: 100%;
            width: 100%;

            .bg {
              display: none;
            }
          }
        }
      }
    }

    .no_copy {
      margin-top: 50px;
      font-size: 12px;
      white-space: nowrap;
      transform: scale(.8);
      display: flex;
      justify-content: center;
      text-align: center;
      flex-wrap: wrap;
      span{
        display: none;
      }
    }
  }
}
</style>
